export default __webpack_public_path__ + "static/d20-bff032eb2fc425ce029e3826bf1cb7c5.png";